import React, { useState } from 'react';
import FormField, { TextInput, SelectInput } from '../common/FormField';

export default function RequirementPicker({ label, requirements = [], selected = {}, onSelect }) {
  const [search, setSearch] = useState(''), [id, setId] = useState('');
  const available = requirements.filter(r => !Object.prototype.hasOwnProperty.call(selected, r.id));
  const matches = available.filter(r => `${r.title} ${r.id}`.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase()));
  return <div className="classifier-stack classifier-requirement-picker">
    <FormField label={label} hint="Найдите требование по названию. Технический код вводить не нужно.">
      <TextInput value={search} placeholder="Поиск требования" onChange={e => { setSearch(e.target.value); setId(''); }} />
    </FormField>
    <div className="classifier-toolbar">
      <FormField label="Найденные требования"><SelectInput value={id} onChange={e => setId(e.target.value)}>
        <option value="">{matches.length ? `Выберите требование (${matches.length})` : 'Совпадений нет'}</option>
        {matches.map(r => <option key={r.id} value={r.id}>{r.title} · {r.id}</option>)}
      </SelectInput></FormField>
      <button type="button" className="ap-button ap-button--secondary" disabled={!matches.some(r => r.id === id)} onClick={() => { onSelect(id); setId(''); }}>Добавить требование</button>
    </div>
  </div>;
}
